import './App.css';
import Main from "./Pages/Main";

function App() {
  return (
    <Main />
  );
}


export default App;
